import { API_CONFIG} from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

export const GetLastEntry = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/get-last-entry`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "Ipdentries fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};